import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-custact-calc-adjust-disc',
  templateUrl: './custact-calc-adjust-disc.component.html',
  styleUrls: ['./custact-calc-adjust-disc.component.css']
})
export class CustactCalcAdjustDiscComponent implements OnInit {
    custactNo;

    public edit?: Edit;

    public executing = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
    }

    private async loadEdit() {
        if (!!this.custactNo) {
            this.edit = (await this.datatask.Post(1249, { custact_no: this.custactNo }))[0];
        }
    }

    public async executeChanges() {
        if (!!this.edit) {
            try {
                this.executing = true;

                const response = (await this.datatask.Post(1250, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.executing = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    custact_no: string;
    cost_pst_add: string;
}
